import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Asset, PaginateResponse } from '@tacliatech/types';

@Injectable({
  providedIn: 'root',
})
export class AssetSearchService {
  constructor(private http: HttpClient) {}

  search(query: { [key: string]: any } = {}) {
    const params = new HttpParams({
      fromObject: {
        ...query,
      },
    });

    return this.http.get<PaginateResponse<Asset.Output[]>>(
      `:API_URL/search/assets`,
      {
        params,
      }
    );
  }
}
